import { useForm } from "react-hook-form";
import { ModalValidTerm } from '../ModalValidTerm';


import { Button } from '../Button';
import { useInduction } from "../../hooks/useInduction";

import { EMAIL_PATTERN } from "../../util/pattern";
import { ISearchFormInput } from "../../util/types/Search";
import { Container, Form } from "./styles";
import Input from "../Form/Input";
import { acceptanceTermEmailOnlyBenefitIds } from "../../util/aliasHidden";

export function Search() {
    const { saveInformationNewTableToSendTerm, handleEditContact, closeModalErroAddBeneficiaryPreCad, benefitId, benefitName, beneficiaryIdentifier, editContact, beneficiaryInfo, errorAddBeneficiaryPreCad, errorAddBeneficiaryPreCadMessage } = useInduction();

    const { register, handleSubmit, errors } = useForm();
    const isEmailOnlyBenefit = acceptanceTermEmailOnlyBenefitIds.includes(benefitId);

    async function handleGetBeneficiary(data: ISearchFormInput) {
        saveInformationNewTableToSendTerm(data);
    }

    async function handleSubmitEditContact(data: ISearchFormInput) {
        await handleEditContact(data);
    }

    function formatToPattern(value: any, pattern: any) {
        if (!value)
            return '';

        let i = 0;
        const v = value.toString();
        return pattern.replace(/#/g, (_: any) => v[i++]);
    }

    return (
        <Container>
            <h1>{benefitName}</h1>
            {!editContact ? (
                <Form onSubmit={handleSubmit(handleGetBeneficiary)}>
                    <div className="control">
                        <Input
                            label="CPF do Beneficiário"
                            type="text"
                            name="cpf"
                            mask="999.999.999-99"
                            register={register}
                            errors={errors}
                            placeholder="CPF do Beneficiário"
                            errorMessage='Campo Obrigatório'
                            min={14}
                            required={true}
                            defaultValue={formatToPattern(beneficiaryIdentifier, '###.###.###-##')}
                        />
                    </div>

                    <div className="control">
                        <Input
                            label="E-mail"
                            name="email"
                            register={register}
                            errors={errors}
                            placeholder="emaildobeneficiario@programa.com"
                            errorMessage='Campo Obrigatório'
                            patt={EMAIL_PATTERN('Email')}
                            min={4}
                            required={true}
                        />
                    </div>
                    <div className="control">
                        <Input
                            label="Telefone celular"
                            type="text"
                            mask="(99) 9 9999-9999"
                            name="celular"
                            register={register}
                            errors={errors}
                            placeholder="(99) 9 9999-9999"
                            errorMessage='Campo Obrigatório'
                            min={16}
                            required={true}
                        />
                    </div>

                    <div className="info-container">
                        <span className="info-name">
                            Em qual canal o beneficiário prefere receber <br />
                            <span className="bold">o termo de aceite</span> do programa {benefitName}?
                        </span>
                    </div>
                    <div className="radioBoxes">
                        <div className="radio-container">
                            <input
                                id="check-email"
                                type="radio"
                                name="tipoEnvio"
                                value="email"
                                defaultChecked={isEmailOnlyBenefit}
                                ref={register({
                                    required: {
                                        value: true,
                                        message: 'Campo Obrigatório'
                                    }
                                })}
                            />
                            <label htmlFor="check-email">Por E-mail</label>
                        </div>
                        {!isEmailOnlyBenefit && (
                            <div className="radio-container">
                                <input
                                    id="check-sms"
                                    type="radio"
                                    name="tipoEnvio"
                                    value="sms"
                                    ref={register({
                                        required: {
                                            value: true,
                                            message: 'Campo Obrigatório'
                                        }
                                    })}
                                />
                                <label htmlFor="check-sms">Por SMS</label>
                            </div>
                        )}
                    </div>
                    {errors['tipoEnvio'] && <span className="input-error-message">{errors['tipoEnvio'].message}</span>}

                    <div className="button-container">
                        <Button id="searchButton" type="submit" isActive={false}>
                            Enviar
                        </Button>
                    </div>

                </Form>
            ) : (
                <Form onSubmit={handleSubmit(handleSubmitEditContact)}>
                    <div className="control">
                        <Input
                            label="CPF do Beneficiário"
                            type="text"
                            name="cpf"
                            mask="999.999.999-99"
                            register={register}
                            errors={errors}
                            placeholder="CPF do Beneficiário"
                            errorMessage='Campo Obrigatório'
                            min={14}
                            required={true}
                            defaultValue={formatToPattern(beneficiaryInfo?.cpf, '###.###.###-##')}
                        />
                    </div>

                    <div className="control">
                        <Input
                            label="E-mail"
                            name="email"
                            register={register}
                            errors={errors}
                            placeholder="emaildobeneficiario@programa.com"
                            errorMessage='Campo Obrigatório'
                            patt={EMAIL_PATTERN('Email')}
                            min={4}
                            required={true}
                            defaultValue={beneficiaryInfo?.email}
                        />
                    </div>
                    <div className="control">
                        <Input
                            label="Telefone celular"
                            type="text"
                            mask="(99) 9 9999-9999"
                            name="celular"
                            register={register}
                            errors={errors}
                            placeholder="(99) 9 9999-9999"
                            errorMessage='Campo Obrigatório'
                            min={16}
                            required={true}
                            defaultValue={beneficiaryInfo?.celular}
                        />
                    </div>

                    <div className="info-container">
                        <span className="info-name">
                            Em qual canal o beneficiário prefere receber <br />
                            <span className="bold">o termo de aceite</span> do programa {benefitName}?
                        </span>
                    </div>
                    <div className="radioBoxes">
                        <div className="radio-container">
                            <input
                                id="check-email"
                                type="radio"
                                name="tipoEnvio"
                                value="email"
                                defaultChecked={isEmailOnlyBenefit || beneficiaryInfo?.tipoEnvio === 'email'}
                                ref={register({
                                    required: {
                                        value: true,
                                        message: 'Campo Obrigatório'
                                    }
                                })}
                            />
                            <label htmlFor="check-email">Por E-mail</label>
                        </div>
                        {!isEmailOnlyBenefit && (
                            <div className="radio-container">
                                <input
                                    id="check-sms"
                                    type="radio"
                                    name="tipoEnvio"
                                    value="sms"
                                    defaultChecked={beneficiaryInfo?.tipoEnvio === 'sms'}
                                    ref={register({
                                        required: {
                                            value: true,
                                            message: 'Campo Obrigatório'
                                        }
                                    })}
                                />
                                <label htmlFor="check-sms">Por SMS</label>
                            </div>
                        )}
                    </div>
                    {errors['tipoEnvio'] && <span className="input-error-message">{errors['tipoEnvio'].message}</span>}

                    <div className="button-container">
                        <Button id="searchButton" type="submit" isActive={false}>
                            Enviar
                        </Button>
                    </div>

                </Form>
            )}
            <ModalValidTerm
                show={errorAddBeneficiaryPreCad}
                content={errorAddBeneficiaryPreCadMessage}
                onClose={closeModalErroAddBeneficiaryPreCad}
                onCloseX={closeModalErroAddBeneficiaryPreCad}
            />
        </Container>
    )
}
